export class SummExpense {
    year: number;
    month: number;
    dealerShipId: number;
    productId: string;
    totalTargetBudget: number;
    totalActualBudget: number;
    expensesPercents: [{
        id:number,
        targetPercent:number,
        actualPercent:number
    }];
    constructor (year,month,dealerShipId,productId,totalTargetBudget,totalActualBudget,expenses){
        this.year = year;
        this.month = month;
        this.dealerShipId = dealerShipId;
        this.productId = productId;
        this.totalTargetBudget = totalTargetBudget;
        this.totalActualBudget = totalActualBudget;
        this.expensesPercents = expenses.map((item) => {
            return { id: item.id, targetPercent: item.targetBudgetPercent, actualPercent: item.actualBudgetPercent };//item.percent;//Math.round(((this.product.price * item.percent) / 100) * 100) / 100;
        })
    }
}


// WEBPACK FOOTER //
// ./src/app/components/add-campaign/class/summ-expense.ts